/* 検索項目 データリスト */
import React, { memo } from 'react';
import SearchLabel from '../atoms/SearchLabel';
import { Col } from 'react-bootstrap';
import { nullChecker } from '../Common';
import Messages from './Messages';
import { FormControl } from 'react-bootstrap';
var SearchDataList = function (_a) {
    var id = _a.id, class_name = _a.class_name, name = _a.name, label = _a.label, value = _a.value, sources = _a.sources, column = _a.column, help_message = _a.help_message, onChange = _a.onChange;
    return (React.createElement(Col, { md: column ? column : 6 },
        React.createElement(SearchLabel, { label: label }),
        React.createElement("div", { className: "search-form-input long " + (class_name !== null && class_name !== void 0 ? class_name : '') },
            React.createElement(FormControl, { type: "text", name: name, list: id, value: value, onChange: onChange }),
            React.createElement("datalist", { id: id }, sources.map(function (src) {
                return (React.createElement("option", { key: src.key, value: src.key }, src.value));
            }))),
        nullChecker(help_message) && React.createElement(Messages, { help_msg: help_message })));
};
export default memo(SearchDataList);
